var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCliIntegration({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 2H6C3.75 2 2 3.8125 2 6V26C2 28.25 3.75 30 6 30H26C28.1875 30 30 28.25 30 26V6C30 3.8125 28.1875 2 26 2ZM27 26C27 26.5625 26.5 27 26 27H6C5.4375 27 5 26.5625 5 26V6C5 5.5 5.4375 5 6 5H26C26.5 5 27 5.5 27 6V26ZM17 16C17 15.625 16.8125 15.1875 16.5 14.9375L10.5 9.4375C9.875 8.875 8.9375 8.875 8.375 9.5C7.8125 10.125 7.875 11.0625 8.4375 11.625L13.25 16L8.4375 20.4375C7.875 21 7.8125 21.9375 8.375 22.5625C8.6875 22.875 9.0625 23 9.5 23C9.8125 23 10.1875 22.875 10.5 22.625L16.5 17.125C16.8125 16.875 17 16.4375 17 16ZM22.5 21H15.5C14.625 21 14 21.6875 14 22.5C14 23.375 14.625 24 15.5 24H22.5C23.3125 24 24 23.375 24 22.5C24 21.6875 23.3125 21 22.5 21Z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCliIntegration);
export default __webpack_public_path__ + "static/media/cli-integration.04b6de358fe35ed87a82da99316ae6ae.svg";
export { ForwardRef as ReactComponent };